module.exports = __webpack_public_path__ + "static/assets/831dfe033433a28e68b9941bb9e1a7a1.gif";